<label>
  <span>Gallery</span>
  <select [ngModel]="block.galleryId" (ngModelChange)="updateGalleryId($event)">
    <option [ngValue]="null">Select gallery</option>
    @for (gallery of availableGalleries; track gallery.id) {
      <option [ngValue]="gallery.id">{{ gallery.name }}</option>
    }
  </select>
</label>

@if (selectedGallery) {
  <p class="field-note">{{ selectedGallery.imageCount }} image{{ selectedGallery.imageCount === 1 ? '' : 's' }} in {{ selectedGallery.name }}</p>
}
